const heightRegExp = /^<svg[^>]*\sheight="(\d+)"/;
const widthRegExp = /^<svg[^>]*\swidth="(\d+)"/;
const viewBoxRegExp = /^<svg[^>]*\sviewBox="0 0 (\d+) (\d+)"/;
const subViewBoxRegExp = /^0 0 (\d+) (\d+)/;

// Cast an index at an array to a number. Defaults to 0.
const numberAt = (match, index) => match ? Number(match[index]) || 0 : 0;

// Determine the dimensions of the provided SVG.
const extractDimensions = (svg, height, width) => {
  // Use provided dimensions if they are nonzero.
  if (height && width) {
    return {
      height,
      width
    };
  }

  // First try to grab the values off of the newly extracted type of svg that is a
  // function that returns a react element that has defaultProps, otherwise assume
  // it's an old style svg string that we need to more fully parse
  if (svg && typeof svg !== 'string' && svg.defaultProps) {
    if (svg.defaultProps.width && svg.defaultProps.height) {
      return {
        width: Number(svg.defaultProps.width),
        height: Number(svg.defaultProps.height)
      };
    } else if (svg.defaultProps.viewBox) {
      const viewBoxMatch = svg.defaultProps.viewBox.match(subViewBoxRegExp);
      const viewBoxDims = {
        height: numberAt(viewBoxMatch, 2),
        width: numberAt(viewBoxMatch, 1)
      };
      if (viewBoxDims.height && viewBoxDims.width) {
        return viewBoxDims;
      }
    }
  } else if (typeof svg === 'string') {
    // First fallback: height/width props defined on the svg root element.
    const propDims = {
      height: numberAt(svg.match(heightRegExp), 1),
      width: numberAt(svg.match(widthRegExp), 1)
    };
    if (propDims.height && propDims.width) {
      return propDims;
    }

    // Second fallback: viewBox prop defined on the svg root element.
    const viewBoxMatch = svg.match(viewBoxRegExp);
    const viewBoxDims = {
      height: numberAt(viewBoxMatch, 2),
      width: numberAt(viewBoxMatch, 1)
    };
    if (viewBoxDims.height && viewBoxDims.width) {
      return viewBoxDims;
    }
  }
  throw new Error('SVG has no dimensions.');
};
export default extractDimensions;